module.exports = __webpack_public_path__ + "dd32b427ec241a8b6f91042323417068.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/mosorder.jpg
 ** module id = 742
 ** module chunks = 0
 **/